module.exports = __webpack_public_path__ + "static/media/social5.8aa4d49a.png";